module.exports = __webpack_public_path__ + "img/undertakingCases2.86a9a043.jpg";